import React from "react";
import Rating from "./Rating/Rating";
import "./RatingTab.scss";

type Rate = {
    question: string;
    rate?: number;
    setRate: (rate?: number) => void;
};

type Props = {
    ratings: Rate[];
};

const RatingTab: React.FC<Props> = ({ ratings }) => {
    return (
        <div className="feedback__rating__tab">
            <h6>Step 1: Rating</h6>
            {ratings.map((rate, idx) => (
                <React.Fragment key={idx}>
                    <div className="devider"></div>
                    <Rating
                        index={idx}
                        question={rate.question}
                        rating={rate.rate}
                        setRating={rate.setRate}
                    />
                </React.Fragment>
            ))}
        </div>
    );
};

export default RatingTab;
